<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">{{ $t("message.Quiz Popup") }}</label>
          <div class="col-sm-3" style="margin-top: 4px">
            <input type="checkbox" class="switch" v-model="quizSwitch" @change="changeSwitch">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import config from "../config";
import axios from "axios"

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  data() {
    return {
      quizSwitch: false,
    };
  },
  created: function() {
    this.getQuizSwitch();
  },
  methods: {
		async getQuizSwitch() {
      let obj = this.getAuthObj;
			let { data } = await this.$store.dispatch("getQuizSwitch", this.setFormData(obj));
			this.quizSwitch = data.result;
    },
    async changeSwitch() {
      let obj = this.getAuthObj;
      obj.status = this.quizSwitch
      await this.$store.dispatch("saveQuizSwitch", this.setFormData(obj));
    }
  },
  mounted() {
  },
};
</script>